let moduleName = 'contentfulservices';

class ContentFulFactory {

    constructor($http, $q, CONFIG, $cookies) {
        //Setting variables
        this.http = $http;
        this.q = $q;
        this.const = CONFIG;
        this.contentful = require('contentful-management');
        this.$cookies = $cookies;
        console.log('content_management_api_key', $cookies.get('accessToken'));

        this.createClient();
    }

    createClient () {
        if (!!this.$cookies.get('accessToken')) {
            this.client = this.contentful.createClient({
                // This is the access token for this space. Normally you get the token in the Contentful web app
                accessToken: this.$cookies.get('accessToken')
            });
        }
    }

    createAssetFromFiles () {
        if (!!!this.client) {
            this.createClient();
        }

        return this.client.getSpace(this.const.space_id);
    }

    getAccessToken () {
        let config = {
            headers: {
                'X-Auth-Token': this.$cookies.get('token')
            }
        };
        this.http.get(`${this.const.customUploadUrl}manage/contentful/access_token`, config).then((data)=> {
            $cookies.put('accessToken', data.data.accessToken);
        });
    }

    getKeywordsService (contentType, limit = 1000, skip) {
        let endpoint = `entries?limit=${limit}&select=fields.keywords&content_type=${contentType}&order=-sys.updatedAt&sys.type[ne]=${(new Date()).valueOf()}`;
        endpoint += `&skip=${skip}`;

        return this.http.get(`${this.const.customUploadUrl}contentful/${endpoint}`);
    }

    static contentFulFactory($http, $q, CONFIG, $cookies){
        return new ContentFulFactory($http, $q, CONFIG, $cookies);
    }
}

ContentFulFactory.contentFulFactory.$inject = ['$http', '$q', 'CONFIG', '$cookies'];

angular.module(moduleName, [])
    .factory('ContentFulFactory', ContentFulFactory.contentFulFactory);


export default moduleName;



// WEBPACK FOOTER //
// ./src/app/services/contentfulFactory.js